import { ClickableIcon } from '@client/new/components/basic';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';

export const DeleteSection = ({ onDelete }: { onDelete: () => void }) => {
  return (
    <ClickableIcon
      warn
      icon={faTrash}
      title="Delete"
      onClick={() => {
        if (window.confirm('Do you really want to delete this section?')) {
          onDelete();
        }
      }}
    />
  );
};
